<template>
  <div id="withdraw_record">
    <!-- 顶部导航栏 -->
    <van-nav-bar 
      :title="$t('title.withdraw_record')" 
      placeholder 
      safe-area-inset-top 
      @click-left="onClickLeft" 
      left-arrow 
    />
    
    <!-- 提现记录列表 -->
    <van-col span="22" offset="1" class="withdraw_record_list">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('other.there_is_no_more')"
        :loading-text="$t('other.Loading')"
        @load="onLoad"
      >
        <van-cell 
          v-for="(item, index) in list" 
          :key="index" 
          class="withdraw_record_item"
          @click="viewOrderDetail(item)"
        >
          <van-col span="14" class="withdraw_record_left">
            <van-col span="24" class="withdraw_record_amount">
              {{ $t('column.Withdrawal_Amount') }}
            </van-col>
            <van-col span="24" class="withdraw_record_time">
              {{ item.create_time }}
            </van-col>
          </van-col>
          <van-col span="10" class="withdraw_record_right">
            <van-col span="24" class="withdraw_record_money">
              ${{ item.dollar_amount }} <van-icon name="arrow" size="14" color="#2F2F2F"/>
            </van-col>
            <van-col span="24" class="withdraw_record_status">
              {{ item.result_text }}
            </van-col>
          </van-col>
        </van-cell>
      </van-list>
    </van-col>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import axios from "axios";

export default {
  name: 'WithdrawRecord',
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1
    }
  },
  created() {
    this.get_list()
  },
  methods: {
    // 上拉加载
    onLoad() {
      if (this.page > 1) {
        this.get_list()
      }
    },
    
    // 获取提现记录列表
    get_list() {
      this.loading = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=get_withdrawal_record_list", {
        params: {
          uid: uid,
          token: token,
          p: this.page
        }
      }).then(res => {
        this.loading = false;
        if (res.data.status === 1) {
          if (this.page === 1) {
            this.list = []
          }
          for (let j = 0; j < res.data.data.list.length; j++) {
            this.list.push(res.data.data.list[j])
          }
          // 如果列表数据条数 < 20，不再触发滚动加载
          if (res.data.data.list.length < 20) {
            this.finished = true
          }
          this.page++
        } else {
          Toast(res.data.error)
        }
      }).catch(err => {
        this.loading = false;
        Toast(this.$t('other.network_error'))
      })
    },
    
    // 点击跳转到订单详情
    viewOrderDetail(item) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      const orderId = item.order_id
      
      this.$router.push({ 
        path: '/withdraw_payroll_order', 
        query: { 
          uid: uid, 
          token: token, 
          order_id: orderId 
        } 
      })
    },
    
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
#withdraw_record {
  min-height: 100vh;
  background: #ffffff;
  .van-nav-bar .van-icon {
  color:#323233!important;
}
}
#withdraw_record .van-nav-bar {
  background-color: unset;
}

#withdraw_record .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

.withdraw_record_list {
  margin-top: 2vw;
}

.withdraw_record_item {
  border-radius: 3vw;
  margin-top: 3vw;
  padding: 4vw 3vw;
  border-bottom: 1px solid #F2F2F2;
}

.withdraw_record_left {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.withdraw_record_amount {
  color: #2F2F2F;
  font-size: 1rem;
  font-weight: 500;
  line-height: 6vw;
  margin-bottom: 2vw;
}

.withdraw_record_time {
  color: #8F8F8F;
  font-size: 0.8rem;
  line-height: 5vw;
}

.withdraw_record_right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

.withdraw_record_money {
  color: #2F2F2F;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 6vw;
  margin-bottom: 2vw;
  text-align: right;
}

.withdraw_record_status {
  font-size: 0.8rem;
  line-height: 5vw;
  text-align: right;
  color: #BEBEBE;
}


</style>



// WEBPACK FOOTER //
// src/components/withdraw_record.vue